import { Action } from '@ngrx/store';
import { HttpErrorResponse } from '@angular/common/http';
import { GenericValidateResponse, GenericUploadResponse } from '../../models/generic-bulk-upsert.model';

export enum GenericBulkUpsertActionTypes {
  ValidateFile = '[GenericBulkUpsert] Validate File',
  ValidateFileSuccess = '[GenericBulkUpsert] Validate File Success',
  ValidateFileFailure = '[GenericBulkUpsert] Validate File Failure',
  UploadFile = '[GenericBulkUpsert] Upload File',
  UploadFileSuccess = '[GenericBulkUpsert] Upload File Success',
  UploadFileFailure = '[GenericBulkUpsert] Upload File Failure',
  ResetState = '[GenericBulkUpsert] Reset State'
}

export class ValidateFile implements Action {
  readonly type = GenericBulkUpsertActionTypes.ValidateFile;
  constructor(public payload: { file: File, endpointUrl: string }) {}
}

export class ValidateFileSuccess implements Action {
  readonly type = GenericBulkUpsertActionTypes.ValidateFileSuccess;
  constructor(public payload: GenericValidateResponse) {}
}

export class ValidateFileFailure implements Action {
  readonly type = GenericBulkUpsertActionTypes.ValidateFileFailure;
  constructor(public payload: HttpErrorResponse) {}
}

export class UploadFile implements Action {
  readonly type = GenericBulkUpsertActionTypes.UploadFile;
  constructor(public payload: { file: File, endpointUrl: string }) {}
}

export class UploadFileSuccess implements Action {
  readonly type = GenericBulkUpsertActionTypes.UploadFileSuccess;
  constructor(public payload: GenericUploadResponse) {}
}

export class UploadFileFailure implements Action {
  readonly type = GenericBulkUpsertActionTypes.UploadFileFailure;
  constructor(public payload: HttpErrorResponse) {}
}

export class ResetState implements Action {
  readonly type = GenericBulkUpsertActionTypes.ResetState;
}

export type GenericBulkUpsertActions =
  | ValidateFile
  | ValidateFileSuccess
  | ValidateFileFailure
  | UploadFile
  | UploadFileSuccess
  | UploadFileFailure
  | ResetState;